export default "__VITE_ASSET__C8k28XkB__"